export const BLOCK_TYPES = {
  HERO_BLOCK: "hero_block",
  COLLECTION_BLOCK: "collection_block",
  TEXT_BLOCK: "text_block",
  AVATAR_BLOCK: "avatar_block",
  BUTTON_BLOCK: "button_block",
  ATTACHMENT_BLOCK: "attachment_block",
  IFRAME_BLOCK: "iframe_block",
  CHAT_BLOCK: "chat_block",
  LIVESTREAM_BLOCK: "livestream_block",
  IMAGE_BLOCK: "image_block",
  SHARE_BLOCK: "share_block",
  WORKOUT_BLOCK: "workout_block",
  ICON_LIST_BLOCK: "icon_list_block",
  MAP_BLOCK: "map_block",
  COMPOSED_BLOCK: "composed_block",
  FEED_BLOCK: "feed_block",
  FORM_SUBMISSION_BLOCK: "form_submission_block",
  SEARCH_BLOCK: "search_block",
};

// We scale the heights of select blocks (Hero, Map, etc)
// off a "base" size of 375px width & 800px height.
//
// This is representative of a generic smartphone.
export const BASE_HEIGHT = 800;
export const BASE_WIDTH = 375;
